/** Handle mixer and AudioContext */

import { useContext } from 'react'
import { AudioEngineContext } from '../engine/audio-engine-context.js'
import type { AudioEngine } from '../engine/engine.js'

/** Mixer. Will resume the audio context once on any click. */
export const useAudioEngine = <T extends boolean | undefined = false>(
  allowNull: T = false as T
): T extends true ? AudioEngine | null : AudioEngine => {
  const engine = useContext(AudioEngineContext)
  if (!engine && !allowNull) {
    throw new Error('No audio engine set in AudioEngineContext')
  }

  return engine as T extends true ? AudioEngine | null : AudioEngine
}
